
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('programming-browser-1')]),_c('path',{staticClass:"a",attrs:{"d":"M2.25,21.75a1.5,1.5,0,0,1-1.5-1.5V3.865A1.62,1.62,0,0,1,2.365,2.25H21.643A1.612,1.612,0,0,1,23.25,3.857V20.135a1.62,1.62,0,0,1-1.615,1.615Z"}}),_c('line',{staticClass:"a",attrs:{"x1":"23.25","y1":"6.75","x2":"0.75","y2":"6.75"}}),_c('line',{staticClass:"a",attrs:{"x1":"12.75","y1":"14.25","x2":"17.25","y2":"14.25"}}),_c('polyline',{staticClass:"a",attrs:{"points":"6.75 11.25 9.75 14.25 6.75 17.25"}})])])
          )
        }
      }
    